import { DEFAULT_LIGHT_PALETTE } from '@theme/light.const'
import chroma from 'chroma-js'

const DEFAULT_PRIMARY_COLOR = DEFAULT_LIGHT_PALETTE.primary

function getPrimaryColor(primaryColor: string = DEFAULT_PRIMARY_COLOR) {
  return {
    name: 'primary', // primary
    variable: '--p',
    value: chroma(primaryColor).oklch().join(' '),
  }
}

const DEFAULT_COLOR_PALETTE = [
  {
    name: 'secondary', // primary4
    variable: '--s',
    value: '82.7% 0.037 275.267',
  },
  {
    name: 'neutral', // primary5
    variable: '--n',
    value: '91.45% 0.015 277.8371',
  },
  {
    name: 'accent',
    variable: '--a',
    value: '53.1% 0.218 29.234',
  },

  {
    name: 'base-200',
    variable: '--b2',
    value: '95% 0.004 271.37',
  },
  {
    name: 'base-300',
    variable: '--b3',
    value: '90% 0.004 271.37',
  },
]

const GRAY_COLOR_PALETTE = [
  {
    name: 'secondary', // primary4
    variable: '--s',
    value: '84.8% 0 0',
  },
  {
    name: 'neutral', // primary5
    variable: '--n',
    value: '91.6% 0 0',
  },
  {
    name: 'accent',
    variable: '--a',
    value: '53.1% 0.218 29.234',
  },

  {
    name: 'base-200',
    variable: '--b2',
    value: '95% 0 0',
  },
  {
    name: 'base-300',
    variable: '--b3',
    value: '90% 0 0',
  },
]

const FIXED_COLOR_PALETTE = [
  {
    name: 'info',
    variable: '--in',
    value: '75.9% 0.106 224.524',
  },
  {
    name: 'success',
    variable: '--su',
    value: '72.48% 0.2006 133.4374',
  },
  {
    name: 'warning',
    variable: '--wa',
    value: '82.19% 0.1689 96.3147',
  },
  {
    name: 'error',
    variable: '--er',
    value: '51.1% 0.194 18.902',
  },

  {
    name: 'base-100',
    variable: '--b1',
    value: '100% 0 0',
  },

  {
    name: 'base-content',
    variable: '--bc',
    value: '20% 0 0',
  },
  {
    name: 'primary-content',
    variable: '--pc',
    value: '100% 0 0',
  },
  {
    name: 'secondary-content',
    variable: '--sc',
    value: '20% 0 0',
  },
  {
    name: 'accent-content',
    variable: '--ac',
    value: '100% 0 0',
  },
  {
    name: 'neutral-content',
    variable: '--nc',
    value: '20% 0 0',
  },
  {
    name: 'info-content',
    variable: '--inc',
    value: '20% 0 0',
  },
  {
    name: 'success-content',
    variable: '--suc',
    value: '20% 0 0',
  },
  {
    name: 'warning-content',
    variable: '--wac',
    value: '20% 0 0',
  },
  {
    name: 'error-content',
    variable: '--erc',
    value: '100% 0 0',
  },
]

function generateColors(newPrimaryColor: string | null = DEFAULT_PRIMARY_COLOR) {
  if (!newPrimaryColor || newPrimaryColor === DEFAULT_PRIMARY_COLOR) {
    return [getPrimaryColor(), ...DEFAULT_COLOR_PALETTE, ...FIXED_COLOR_PALETTE]
  } else {
    return [getPrimaryColor(newPrimaryColor), ...GRAY_COLOR_PALETTE, ...FIXED_COLOR_PALETTE]
  }
}

export async function applyDaisyUiTheme(primaryColor: string | null = DEFAULT_PRIMARY_COLOR) {
  const colorPalette = generateColors(primaryColor)
  colorPalette.forEach((color) => {
    document.documentElement.style.setProperty(color.variable, color.value)
  })
}
